module.exports = __webpack_public_path__ + "assets/edit-menu.8eda4c14.svg";